import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ShareLinkType } from './useTrackBrandContextSelected';
import META from './useTrackCustomLogoAdded.meta';

export type UseTrackCustomLogoAddedParams = {
  share_link_type: ShareLinkType;
  from_brand_context: boolean;
};

export const useTrackCustomLogoAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackCustomLogoAdded = useCallback(
    (params: UseTrackCustomLogoAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCustomLogoAdded };
};
